function removeEmpty(obj) {
  if (Array.isArray(obj)) {
    return obj.map(v => (v && typeof v === 'object' ? removeEmpty(v) : v)).filter(v => !(v == null || v === ''));
  } else {
    return Object.entries(obj)
      .map(([k, v]) => [k, v && typeof v === 'object' ? removeEmpty(v) : v])
      .reduce((a, [k, v]) => (v == null || v === '' ? a : ((a[k] = v), a)), {});
  }
}

export default removeEmpty;
